import { render, staticRenderFns } from "./_jdb.vue?vue&type=template&id=320b6960&lang=pug&"
import script from "./_jdb.vue?vue&type=script&lang=js&"
export * from "./_jdb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports